<div main class="flex flex-col justify-center items-stretch">
  <div class="home-description">
    <vi-logo left data-at-logo dark="true" class="vitoguide_logo"></vi-logo>
    <div class="home-subtitle">
      <span>{{ '+HOME.HOME.SUBTITLE' | translate }}</span>
    </div>
    <div class="home-img-container !hidden lt-lg:!block">
      <img class="home-img" src="/assets/img/installer-van.png" />
    </div>
    <div class="home-buttons-description" data-at-description>
      {{ '+HOME.HOME.IE_NOT_SUPPORTED' | translate }}
    </div>
    <div class="home-buttons flex flex-row gap-[20px]">
      <a
        gtm="onBrowserSelect"
        gtmLabel="microsoft-edge"
        href="https://www.microsoft.com/windows/microsoft-edge/"
        ><vi-icon name="browser-microsoft-edge-logo" [size]="40"></vi-icon
      ></a>
      <a gtm="onBrowserSelect" gtmLabel="chrome" href="https://www.google.com/chrome/"
        ><vi-icon name="browser-chrome-logo" [size]="40"></vi-icon
      ></a>
      <a gtm="onBrowserSelect" gtmLabel="firefox" href="https://www.mozilla.org/firefox/"
        ><vi-icon name="browser-firefox-logo" [size]="40"></vi-icon
      ></a>
      <a gtm="onBrowserSelect" gtmLabel="opera" href="https://www.opera.com/"
        ><vi-icon name="browser-opera-logo" [size]="40"></vi-icon
      ></a>
    </div>
  </div>
  <div class="cancel-button-wrapper">
    <button
      data-at-cancel-btn
      id="home-browser-support-cancel-dialog-btn"
      gtm="onCancelDialog"
      gtmCategory="browserSupport"
      mat-raised-button
      color="primary"
      (click)="onCancel()"
    >
      {{ 'GENERAL.BUTTON.CANCEL' | translate }}
    </button>
  </div>
</div>
